import React from "react";
import { FiBox, FiClock, FiGlobe } from "react-icons/fi";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/delivery.scss";

function Delivery() {
  return (
    <main className="shipping-page">
      <header><p className="eyebrow">From our desk to yours</p><h1>Shipping policy</h1><p>Orders are packed carefully in Hong Kong with practical, recyclable materials and as little excess as possible.</p></header>
      <section className="shipping-highlights page-shell">
        <article><FiClock /><h2>Dispatch</h2><p>Most orders leave within {siteConfig.shipping.dispatchTime}.</p></article>
        <article><FiBox /><h2>Tracked delivery</h2><p>{formatPrice(siteConfig.shipping.flatRate)} flat rate per order.</p></article>
        <article><FiGlobe /><h2>International</h2><p>Tracked options and final rates are shown at checkout.</p></article>
      </section>
      <section className="shipping-details page-shell section-space">
        <div><p className="eyebrow">Delivery guide</p><h2>Useful things to know</h2></div>
        <div>
          <details open><summary>Hong Kong</summary><p>Tracked delivery usually arrives within {siteConfig.shipping.deliveryEstimate}. Remote areas may require a little longer.</p></details>
          <details><summary>International delivery</summary><p>Delivery commonly takes 7–18 working days. Available non-sanctioned destinations are listed at checkout.</p></details>
          <details><summary>Tracking and delays</summary><p>Where tracking is available, a link is sent after dispatch. If tracking has not moved for seven working days, please contact us.</p></details>
        </div>
      </section>
    </main>
  );
}

export default Delivery;
